/* eslint-disable no-restricted-syntax */
import routeNames from '@/fish/router/constants'

const waterbodyChildren = [
  {
    name: routeNames.WATERBODY_OVERVIEW,
    path: 'overview',
    component: () =>
      import('@/fish/components/waterbodies/waterbody/waterbody-overview'),
  },
  {
    name: routeNames.WATERBODY_WEATHER,
    path: 'weather',
    component: () => import('@/components/weather/query-weather-tab'),
  },
  {
    name: routeNames.FISH_SPECIES,
    path: 'species',
    component: () =>
      import('@/fish/components/waterbodies/query/fish-species-tab'),
  },
  {
    name: routeNames.REGIONS_TAB,
    path: 'regions',
    component: () =>
      import('@/fish/components/waterbodies/waterbody/waterbody-regions-view'),
  },
]
export default [
  {
    name: routeNames.WATERBODIES,
    path: 'waterbodies',
    beforeEnter(to, from, next) {
      to.params.deeplink = !from.name
      next()
    },
    props: true,
    component: () =>
      import(
        /* webpackPrefetch: true */ '@/fish/components/waterbodies/discover/lake-finder'
      ),
  },
  {
    name: routeNames.WATERBODIES_GROUP,
    path: 'waterbodies/waterbodies-group/:type',
    props: true,
    component: () =>
      import('@/fish/components/waterbodies/discover/waterbodies-group'),
  },
  {
    name: routeNames.WATERBODIES_FILTER,
    path: 'waterbodies/filter',
    component: () => import('@/fish/components/filtering/filter-card'),
  },
  {
    name: routeNames.WATER,
    path: 'water',
    component: () =>
      import('@/fish/components/waterbodies/waterbody/waterbody-card'),
    children: [
      {
        name: routeNames.WATERBODY,
        path: 'waterbody/:id',
        redirect: { name: routeNames.WATERBODY_OVERVIEW },
        component: () =>
          import('@/fish/components/waterbodies/waterbody/waterbody'),
        children: waterbodyChildren,
      },
    ],
  },
  {
    name: routeNames.REGION,
    path: 'water/region',
    component: () =>
      import(
        /* webpackPrefetch: true */ '@/fish/components/waterbodies/region/region-card'
      ),
    children: [
      {
        name: routeNames.SUB_REGION,
        path: ':regionId',
        redirect: { name: routeNames.REGION_OVERVIEW },
        component: () =>
          import(
            /* webpackPrefetch: true */ '@/fish/components/waterbodies/region/region'
          ),
        children: [
          // Region not associated with a waterbody
          {
            name: routeNames.REGION_OVERVIEW,
            path: 'overview',
            component: () =>
              import('@/fish/components/waterbodies/region/region-overview'),
          },
          {
            // This name is not used, it is here to suppress router warnings
            name: 'region-root-redirect',
            path: '',
            redirect: { name: routeNames.REGION_OVERVIEW },
          },
          // Region associated with a waterbody
          {
            name: routeNames.REGION_WATERBODY_OVERVIEW,
            path: 'waterbody/:waterbodyId',
            component: () =>
              import('@/fish/components/waterbodies/region/region-overview'),
          },
          {
            name: routeNames.REGION_WATERBODY_SPECIES,
            path: 'waterbody/:waterbodyId/species',
            component: () =>
              import('@/fish/components/waterbodies/query/fish-species-tab'),
          },
          {
            name: routeNames.REGION_WEATHER,
            path: 'weather',
            component: () => import('@/components/weather/query-weather-tab'),
          },
          {
            name: routeNames.REGION_WATERBODY_WEATHER,
            path: 'waterbody/:waterbodyId/weather',
            component: () => import('@/components/weather/query-weather-tab'),
          },
        ],
      },
    ],
  },
  {
    name: routeNames.FISH_SPECIES_INFO,
    path: 'water/waterbody/:id/:regionId?/species-info/:speciesSlug',
    component: () => import('@/fish/components/species/fish-species-card'),
  },
  {
    name: routeNames.FISH_SPECIES_ABUNDANCE_INFO,
    path: 'species-info/abundance',
    component: () =>
      import('@/fish/components/species/info-card-abundance.vue'),
  },
  {
    name: routeNames.FISH_SPECIES_STOCKING_INFO,
    path: 'species-info/:species/stocking',
    component: () => import('@/fish/components/species/info-card-stocking.vue'),
  },
  {
    // Redirect for the "All" quick filter button in Discover
    name: 'fish-mode',
    path: 'discover/mode',
    redirect: {
      name: routeNames.WATERBODIES_FILTER,
      path: 'waterbodies/filter',
      component: () => import('@/fish/components/filtering/filter-card'),
    },
  },
  {
    name: routeNames.FISHING_REPORTS,
    path: 'fishing-reports/:reportId',
    component: () => import('@/fish/components/fishing-reports/report.vue'),
  },
  {
    name: routeNames.FISHING_REPORTS_LIST,
    path: 'fishing-reports/all/:areaId',
    component: () => import('@/fish/components/fishing-reports/list.vue'),
  },
]
